<ion-content>
  <ion-grid class="px-0 pt-0 pb-[5em]">
    <ion-row class="bg-[--primary-white] py-4">
      <ion-col class="flex items-center justify-center max-w-prose m-auto">
        <ion-icon
          name="chevron-back-outline"
          class="mx-2 text-lg bg-white p-2 rounded-lg hover:cursor-pointer shadow"
          (click)="goToAnalyse()"
        ></ion-icon>
        <ion-title class="p-0 sm:mr-8">
          <h1 class="m-0 xs:max-[350px]:!text-2xl">Forbruks&#173;analyse</h1>
        </ion-title>
      </ion-col>
    </ion-row>

    <!-- <ion-row class="max-w-prose my-2 mx-auto">
      <ion-col class="px-2">
        <div class="flex gap-6 items-center">
          <p>{{ lead }}</p>

          <ion-icon
            aria-label="Mer info"
            name="help-circle-outline"
            class="h-[2.5rem] w-[3rem] inline-grid place-items-center bg-white px-2 py-1 rounded-lg hover:cursor-pointer shadow"
            (click)="expandTooltip()"
          ></ion-icon>
        </div>
      </ion-col>
    </ion-row> -->

    @if (objectid) {
    <!-- <ion-row class="mb-4 mx-2">
      <ion-col class="p-2 sm:p-4 max-w-prose mx-auto rounded-lg shadow-lg">
        <app-prices-forbruk-dashboard
          [objectid]="objectid"
        ></app-prices-forbruk-dashboard>
      </ion-col>
    </ion-row> -->

    <ion-row class="my-4 mx-2">
      <ion-col class="p-2 sm:p-4 max-w-prose mx-auto rounded-lg shadow-lg">
        <p class="text-center mt-0 mb-4 text-lg">
          {{ valgtAdresse }}
        </p>

        <app-prices-forbruk
          [objectid]="objectid"
          chartId="prices-forbruk-chart"
        ></app-prices-forbruk>

        <h2 class="text-tundra font-title text-center text-xl min-[1000px]:text-2xl">
          {{dayChartUsageTitle}}
        </h2>

        <app-analyse-day-chart-usage
          *ngIf="valgtAnlegg; else loadingTemplate"
          [valgtAnlegg]="valgtAnlegg"
          [selectedDate]="selectedDate"
          [showOutsideTemperature]="true"
          [meteorologyObservations]="meteorologyObservations"
          [meteorologyForecast]="meteorologyForecast"
        ></app-analyse-day-chart-usage>
      </ion-col>
    </ion-row>
    }

    <ion-row class="mx-2">
      <ion-col class="max-w-prose mx-auto rounded-lg shadow-lg">
        <h2 class="bg-[--primary-strong-100] m-0 p-4 rounded-t-lg">
          Ditt forbruk mot pris
        </h2>
        <p class="mb-0 mx-4">
          Gårsdagens verdier blir kalkulert rundt kl 12:00. Vi tar forbehold om
          feil, da dette er en eksperimentell funksjon.
        </p>
        <div class="p-2 sm:p-4">
          <app-usage-cost-month
            *ngIf="analyzedConsumption.price_days"
            [objectid]="objectid"
            [priceDays]="analyzedConsumption.price_days"
          ></app-usage-cost-month>
          <app-usage-cost-day
            *ngIf="analyzedConsumption.price_hours"
            [objectid]="objectid"
            [priceHours]="analyzedConsumption.price_hours"
          ></app-usage-cost-day>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="my-4">
      <ion-col class="max-w-prose mx-auto px-3">
        <p><strong>Har du prøvd vår strømkalkulator? </strong></p>
        <ion-button
          href="https://www.ishavskraft.no/privat/hva-koster?source=app"
        >
          Se hva de ulike strømforbrukerne koster
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="my-4">
      <ion-col class="max-w-prose mx-auto container-blue">
        <h3><strong>Hva kan du gjøre?</strong></h3>
        <p>
          Hva påvirker strømkostnadene? Hva kan du gjøre for å redusere neste
          strømregning og spare penger? Nedenfor får du noen generelle tips til
          tiltak.
        </p>

        <h3>Spotprisen</h3>
        <div class="bg-[white] rounded-lg px-2 py-4">
          <p class="m-0">
            Spotprisen varierer fra time til time, og ved å flytte forbruket
            ditt til timer med lavere pris kan du spare penger.
            Strømstøtteordningen jevner ut pristoppene, og skjermer deg fra de
            høyeste kostnadene.
          </p>
          <p class="underline hover:cursor-pointer" (click)="navigateToSpot()">
            Klikk her for å se spotprisen time for time
          </p>
        </div>

        <h3>Høy døgnmaks</h3>
        <div class="bg-[white] rounded-lg px-2 py-4">
          <p class="mt-0">
            Tingene som normalt krever mest strøm er lading av elbil, bruk av
            varmtvann, panelovner og kokeplater. Jo mindre av dette man kan
            bruke samtidig, jo bedre.
          </p>
          <p class="mb-0">
            Selv om prisene som regel er rimeligere på natten så anbefaler vi
            ikke å bruke oppvaskmaskin, vaskemaskin eller tørketrommel hvis man
            ikke er våken.
          </p>
        </div>

        <h3>Din nettleie</h3>
        <div class="my-4">
          @if (!hasNoConfig) {
          <div class="rounded-lg bg-white">
            <app-nettleie-advisory
              [analyzeNettleie]="analyzedConsumption.nettleietrinn"
              [errorAnalyse]="errorAnalyse"
            ></app-nettleie-advisory>
          </div>
          } @if (!errorAnalyse) {
          <ion-button (click)="goToNettleie()" class="mt-4 dark">
            Gå til nettleieanalysen
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </ion-button>
          } @else {
          <p>Nettleie-analyse er dessverre utilgjengelig akkurat nå</p>
          }
        </div>

        <h3>Dette bruker strøm</h3>
        <div class="bg-[white] rounded-lg px-2 py-4">
          <p class="mt-0">
            I en vanlig husholdning er det som regel dette som bruker mest
            strøm:
          </p>
          <ol class="list-none bar-chart-list px-4 mb-0">
            <li
              style="--percent: calc(55 / 0.55)"
              class="grid gap-2 my-1 items-center grid-cols-[minmax(0,1fr)_minmax(0,2fr)]"
            >
              <p
                class="grid items-center grid-cols-[5em_minmax(0,1fr)] gap-1 m-0"
              >
                <strong>50-60%</strong>
                <span>Oppvarming</span>
              </p>
            </li>
            <li
              style="--percent: calc(20 / 0.55)"
              class="grid gap-2 my-1 items-center grid-cols-[minmax(0,1fr)_minmax(0,2fr)]"
            >
              <p
                class="grid items-center grid-cols-[5em_minmax(0,1fr)] gap-1 m-0"
              >
                <strong>15-20%</strong>
                <span>Varmtvann</span>
              </p>
            </li>
            <li
              style="--percent: calc(15 / 0.55)"
              class="grid gap-2 my-1 items-center grid-cols-[minmax(0,1fr)_minmax(0,2fr)]"
            >
              <p
                class="grid items-center grid-cols-[5em_minmax(0,1fr)] gap-1 m-0"
              >
                <strong>15%</strong>
                <span>El-apparater</span>
              </p>
            </li>
            <li
              style="--percent: calc(5 / 0.55)"
              class="grid gap-2 my-1 items-center grid-cols-[minmax(0,1fr)_minmax(0,2fr)]"
            >
              <p
                class="grid items-center grid-cols-[5em_minmax(0,1fr)] gap-1 m-0"
              >
                <strong><5%</strong>
                <span>Belysning</span>
              </p>
            </li>
          </ol>
          <p class="mb-0">
            Hvis du har elbil, er dette som regel den tredje største posten
            etter varmtvann.
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="max-w-prose mx-auto px-3 my-4">
        <h3 class="mt-0">Spar penger på neste strømregning</h3>
        <p>
          Strømprisen varierer fra time til time og dag til dag. I analysen vår
          ser vi om det kan være penger å spare for deg ved å være mer bevisst
          på å unngå de dyreste periodene. Så lenge strømstøtten er aktiv vil
          det imidlertid normalt sett være mest penger å spare på nettleien.
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #loadingTemplate>
  <ion-col class="mr-3">
    <div class="loadingContainer">
      <ion-spinner name="dots"></ion-spinner>
    </div>
  </ion-col>
</ng-template>
